import { getStore } from '~/mobx/AppStore';

const getVoteType = (candidateId: string) => {
    const { voteStore } = getStore();
    if (voteStore.votes.some((vote) => vote.candidate_id === candidateId && vote.votes === 2)) {
        return 'extra';
    }
    if (voteStore.votes.some((vote) => vote.candidate_id === candidateId && vote.votes === 0)) {
        return 'down';
    }
    return 'normal';
};
export default getVoteType;
